@if (showBackLink) {
  <div class="row align-items-center aimo-breadcrumb-backlink-wrapper">
    <div class="col-auto backlink">
      @if (showBackLink) {
        <a role="button" class="btn-link" (click)="back()">
          <i class="aimo-icon icon-inline icon-arrow-left icon-sm"></i>
          <span>{{ 'common.back' | cxTranslate }}</span>
        </a>
      }
    </div>
    <div class="col-md-auto col-9">
      <ng-container *ngTemplateOutlet="normalBreadcrumb; context: { styleClass: 'fade-white' }"></ng-container>
    </div>
  </div>
} @else {
  <div class="aimo-breadcrumb-wrapper" [ngClass]="style">
    <div #breadcrumb class="aimo-breadcrumb">
      <nav class="d-inline" [attr.aria-label]="'common.breadcrumbs' | cxTranslate" tabindex="-1">
        <ol>
          <!-- Loop for normal page breadcrumbs -->
          @if (!skipMetaBreadCrumbs) {
            @for (crumb of crumbs$ | async; track crumb.link) {
              <li>
                <a
                  class="d-inline"
                  [attr.aria-label]="'navigation.navigateTo' | cxTranslate: { nav: crumb.label }"
                  [routerLink]="crumb.link"
                [innerHTML]="crumb.label|safeHtml"></a>
                <i class="aimo-icon icon-inline icon-caret-right icon-mid-grey icon-sm"></i>
              </li>
            }
            @if (contentPageTitle) {
              <li>
                <span>{{ contentPageTitle }}</span>
              </li>
            }
          }
          @if (addFrontPageLink) {
            <li>
              <a [routerLink]="'/'">
                <ng-container>
                  {{ 'common.home' | cxTranslate }}
                </ng-container>
              </a>
              <i class="aimo-icon icon-inline icon-caret-right icon-mid-grey icon-sm"></i>
            </li>
          }
          <!-- Loop for category and product page breadcrumbs -->
          @for (crumb of breadCrumbs; track crumb.facetValueCode; let idx = $index; let isLast = $last) {
            <li>
              @if (idx < 3) {
                @if (
                  idx === 2 ? setSecondLevelCategory(crumb.facetValueCode) : ''
                  ) {
                }
                <a routerLink="/category/{{ crumb.facetValueCode }}">
                  {{ crumb.facetValueName }}
                </a>
              }
              @if (idx >= 3) {
                @if (!isLast) {
                  <a
                    routerLink="/category/{{ secondLevelCategory }}"
                                    [queryParams]="{
                                            query:
                                                ':relevance:allCategories:' +
                                                secondLevelCategory +
                                                ':category:' +
                                                crumb.facetValueCode,
                                        }">
                    {{ crumb.facetValueName }}
                  </a>
                }
                @if (isLast) {
                  <span #breadcrumbLastItem>{{ crumb.facetValueName }}</span>
                }
              }
              <i class="aimo-icon icon-inline icon-caret-right icon-mid-grey icon-sm"></i>
            </li>
          }
        </ol>
      </nav>
    </div>
  </div>
}

<ng-template #normalBreadcrumb let-style="styleClass">
  <div class="aimo-breadcrumb-wrapper" [ngClass]="style">
    <div #breadcrumb class="aimo-breadcrumb">
      <nav class="d-inline" [attr.aria-label]="'common.breadcrumbs' | cxTranslate" tabindex="-1">
        <ol>
          <!-- Loop for normal page breadcrumbs -->
          @if (!skipMetaBreadCrumbs) {
            @for (crumb of crumbs$ | async; track crumb.link) {
              <li>
                <a
                  class="d-inline"
                  [attr.aria-label]="'navigation.navigateTo' | cxTranslate: { nav: crumb.label }"
                  [routerLink]="crumb.link"
                [innerHTML]="crumb.label|safeHtml"></a>
                <i class="aimo-icon icon-inline icon-caret-right icon-mid-grey icon-sm"></i>
              </li>
            }
            @if (contentPageTitle) {
              <li>
                <span>{{ contentPageTitle }}</span>
              </li>
            }
          }

          @if (addFrontPageLink) {
            <li>
              <a [routerLink]="'/'">
                <ng-container>
                  {{ 'common.home' | cxTranslate }}
                </ng-container>
              </a>
              <i class="aimo-icon icon-inline icon-caret-right icon-mid-grey icon-sm"></i>
            </li>
          }

          <!-- Loop for category and product page breadcrumbs -->
          @for (crumb of breadCrumbs; track crumb.facetValueCode; let idx = $index; let isLast = $last) {
            <li>
              @if (idx < 3) {
                @if (
                  idx === 2 ? setSecondLevelCategory(crumb.facetValueCode) : ''
                  ) {
                }
                <a routerLink="/category/{{ crumb.facetValueCode }}">
                  {{ crumb.facetValueName }}
                </a>
              }
              @if (idx >= 3) {
                @if (!isLast) {
                  <a
                    routerLink="/category/{{ secondLevelCategory }}"
                                    [queryParams]="{
                                            query:
                                                ':relevance:allCategories:' +
                                                secondLevelCategory +
                                                ':category:' +
                                                crumb.facetValueCode,
                                        }">
                    {{ crumb.facetValueName }}
                  </a>
                }
                @if (isLast) {
                  <span #breadcrumbLastItem>{{ crumb.facetValueName }}</span>
                }
              }
              <i class="aimo-icon icon-inline icon-caret-right icon-mid-grey icon-sm"></i>
            </li>
          }
        </ol>
      </nav>
    </div>
  </div>
</ng-template>

@if ( !hideTitle) {
  <!-- Hidden page title for Screen Reader initialized after view to avoid old values -->
  <span class="cx-visually-hidden" aria-live="polite" aria-atomic="true">
    {{ lastestTitle$ | async }}
  </span>
  <h1>{{ title$ | async }}</h1>
}
